import React from 'react'
import { Text } from 'rebass'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../state'
import { useLocation } from 'react-router-dom'
import useModal from '../../hooks/bakery/useModal'
// const creatHistory = require("history").createHashHistory

// components
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import Tabs from './components/Tabs'
import styled from 'styled-components'
import { updateLevel } from '../../state/market/actions'
import { useMarketLevel } from '../../state/market/hooks'
import UpgradeModal from './components/UpgradeModal'

const activeClassName = 'ACTIVENAV'
const ButtonItem = styled.div.attrs({
  activeClassName
})`
  position: relative;
  width: 100%;
  border-radius: 5px;
  font-family: Baloo Da;
  height: 32px;
  line-height: 32px;
  text-decoration: none;

  &.${activeClassName} {
     background: ${({ theme }) => theme.primary1};
     color: ${({ theme }) => theme.bsText1};
  }
`
const ButtonBox = styled.div`
  cursor: pointer;
  display: flex;
  width: 168px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 6px;
  font-family: Baloo Da;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.bsText3};
  position: relative;
`

const Upgrade = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: -60px;
  margin-bottom: 23px;
  width: 1204px;
`

const UpgradeTxt = styled.div`
  width: 174px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* Linear */
  background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
  border-radius: 10px;
  font-family: Baloo Da;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #FFF3E0;
  text-shadow: 0px 3px 4px #FF8401;
  cursor: pointer;
  animation:scaleMove 2s linear	2s infinite;
  -webkit-animation:scaleMove 2s linear	2s infinite;
  transform: scale(0.8);
  @keyframes scaleMove
  {
    10% {
      transform: scale(1)
    }
    20% {
      transform: scale(0.8)
    }
    100% {
      transform: scale(0.8)
    }
  }
`


// const UpgradeIcon = styled.div`
//   background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
//   width: 28px;
//   line-height: 28px;
//   text-align: center;
//   height: 28px;
//   border-radius: 100%;
//   font-family: Yuanti SC;
//   font-style: normal;
//   font-weight: bold;
//   font-size: 16px;
//   color: #FFF3E0;
//   text-shadow: 0px 3px 4px #FF8401;
//   margin-left: 8px;
// `

const ExchangeTop:React.FC = ({children}) => {
  const level = useMarketLevel()
  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation()
  const change = () => {
    if (
      location.pathname.indexOf('/exchange/seascape/seascapeInfo') > -1 
      || location.pathname.indexOf('/exchange/meme/memeInfo') > -1 
      || location.pathname.indexOf('/exchange/musk-doge/muskdogeInfo') > -1 
      || location.pathname.indexOf('/exchange/digital-artworks/artworkInfo') > -1 
      || location.pathname.indexOf('/exchange/new-artworks/artworkInfo') > -1 
      || location.pathname.indexOf('/exchange/bsc-artworks/artworkInfo') > -1
      ) {
      window.history.back()
      return
    }
    dispatch(updateLevel({level: 'v1'}))
  }
  const change2 = () => {
    if (
      location.pathname.indexOf('/exchange/seascape/seascapeInfo') > -1 
      || location.pathname.indexOf('/exchange/meme/memeInfo') > -1 
      || location.pathname.indexOf('/exchange/musk-doge/muskdogeInfo') > -1 
      || location.pathname.indexOf('/exchange/digital-artworks/artworkInfo') > -1 
      || location.pathname.indexOf('/exchange/new-artworks/artworkInfo') > -1
      || location.pathname.indexOf('/exchange/bsc-artworks/artworkInfo') > -1
      ) {
      window.history.back()
      return
    }
    dispatch(updateLevel({level: 'v2'}))
  }
  const change3 = () => {
    if (
      location.pathname.indexOf('/exchange/seascape/seascapeInfo') > -1 
      || location.pathname.indexOf('/exchange/meme/memeInfo') > -1 
      || location.pathname.indexOf('/exchange/musk-doge/muskdogeInfo') > -1 
      || location.pathname.indexOf('/exchange/digital-artworks/artworkInfo') > -1 
      || location.pathname.indexOf('/exchange/new-artworks/artworkInfo') > -1
      || location.pathname.indexOf('/exchange/bsc-artworks/artworkInfo') > -1
      ) {
      window.history.back()
      return
    }
    dispatch(updateLevel({level: 'v3'}))
  }


  const [onPresentExchange] = useModal(
    <UpgradeModal/>
  )

  return (
    <>
      <BodyHead bottom="23px">
        <BodyTitle fontSize={32} fontWeight={700}>
          NFT Marketplace
        </BodyTitle>
        <Text fontSize={14} fontWeight={500}>
          A market made for NFT, where everything is special {' '}
          <span role="img" aria-label="smile">
            😋
          </span>
        </Text>
        <ButtonBox>
          <ButtonItem className={level === 'v3' ? activeClassName : ''} onClick={change3}>V3</ButtonItem>
          <ButtonItem className={level === 'v2' ? activeClassName : ''} onClick={change2}>V2</ButtonItem>
          <ButtonItem className={level === 'v1' ? activeClassName : ''} onClick={change}>V1</ButtonItem>
        </ButtonBox>
      </BodyHead>
      <Upgrade>
        <UpgradeTxt onClick={() => {onPresentExchange()}}>Upgrade to V3</UpgradeTxt>
        {/* <UpgradeIcon>?</UpgradeIcon> */}
      </Upgrade>
      <Tabs></Tabs>
      {children}
    </>
  )
}

export default ExchangeTop
